import { useEffect, useState } from "react";
import axios from "axios";

/**
 * Is the platform-wide catalogue auto-approve gate ON?
 *
 * Store-facing surfaces use this to decide whether to offer inline "add to
 * catalogue". With the gate OFF a new row lands `pending` — hidden by the
 * backend's catalog scope and refused by the listing/request flow — so
 * offering it would create something the rep then cannot select. The backend
 * refuses too (POST /store-catalog/quick-product 422s), this just avoids
 * showing a dead end.
 *
 * Module-level cache: every product-search surface on a page would otherwise
 * fire its own request, and the flag changes about once a quarter.
 */
let cached = null;
let inFlight = null;

export const primeCatalogAutoApprove = (value) => { cached = !!value; };

export function useCatalogAutoApprove() {
  const [enabled, setEnabled] = useState(cached);

  useEffect(() => {
    let alive = true;
    if (cached !== null) { setEnabled(cached); return () => { alive = false; }; }

    inFlight = inFlight || axios.get("/api/store-catalog/settings")
      .then((res) => { cached = !!res?.data?.auto_approve; return cached; })
      // A 401/403 (not a store admin) means "not available to you" — treat as
      // off rather than surfacing an error on a page that merely searches.
      .catch(() => { cached = false; return false; })
      .finally(() => { inFlight = null; });

    inFlight.then((v) => { if (alive) setEnabled(v); });
    return () => { alive = false; };
  }, []);

  return enabled === true;
}

export default useCatalogAutoApprove;
